import { GridColDef, GridRowModel } from "@mui/x-data-grid"
import { Header, TableStandard } from "ui"
import { useEffect, useState } from "react"
import { RankingItemDto } from "../../__generated__/graphql"
import { Stack, Typography } from "@mui/material"
const TABLE_COLUMNS: GridColDef[] = [
    { field: "rank", headerName: "Rank", flex: 1, sortable: false, resizable: false, disableColumnMenu: true, },
    { field: "question", headerName: "Response", flex: 5, sortable: false, resizable: false, disableColumnMenu: true, }
]
function mapDataToTable(data: any, index: number, prefix: string) {
    return {
        ...data,
        id: `${prefix}-${index}`,
        rank: data.rank,
        question: data.label

    }
}
const TopFlagTable = ({ flags, title }: { flags: RankingItemDto[], title: string }) => {
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[],
        filteredRows: GridRowModel[]
        status: "NORMAL" | "FILTERING"
    }>({
        columns: [],
        rows: [],
        filteredRows: [],
        status: "NORMAL"
    })
    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS]
            const rows = flags?.map((item, index) =>
                mapDataToTable(item, index, title)
            );
            // const rows = flags?.map(mapDataToTable);
            return {
                ...prevState,
                columns,
                rows: rows
            }
        })
    }, [flags])
    return (
        <TableStandard
            renderToolbar={() => (
                <Header title={`Top 5 ${title} Reported`} titleSize="p" />
            )}
            slots={{
                noRowsOverlay: () => <NoTopFlagsOverlay flagType={title} />
            }}
            autoHeight
            columns={pageTableState.columns}
            rows={pageTableState.rows}
            disableBoxShadow
            hideFooter={true}
            loading={false} />
    )
}

function NoTopFlagsOverlay({ flagType }: { flagType: string }) {
    return (
        <Stack height="100%" alignItems="center" justifyContent="center">
            <Typography>
                There is no Top {flagType} Flag Data yet
            </Typography>
        </Stack>
    )
}
export default TopFlagTable